import React from 'react';
import Dashboard from './Dashboard';
import { ModuleProps } from 'types';
import getRoutes from './routes';
import RouteModuleFactory from '../@layout/Router/RouteModuleFactory';

const routes = getRoutes();

const DashboardModule: React.FC<ModuleProps> = moduleProps => {
  return <RouteModuleFactory IndexComponent={Dashboard} routes={routes} {...moduleProps} />;
};

export default DashboardModule;
